import { Pipe, PipeTransform } from '@angular/core';

/**
 * Quantity Pipe convert decimal quantity to fraction
 */
@Pipe({
    name: 'quantity',
    standalone: true
})
export class QuantityPipe implements PipeTransform {

    /**
 * Convert the decimal part from quantity to fraction. Only for the following case:
 *  - 0.25
 *  - 0.5
 *  - 0.75
 * @param quantity Quantity value receive from the medication scheme
 * @returns Quantity converted with fraction instead of decimal
 */
    transform(quantity: number): string {
        if (quantity) {
            const remain = quantity % 1;
            const base = Math.floor(quantity) > 0 ? `${Math.floor(quantity)} + ` : '';
            if (remain === 0.25) {
                return `${base}¼`;
            } else if (remain === 0.5) {
                return `${base}½`;
            } else if (remain === 0.75) {
                return `${base}¾`;
            } else {
                return quantity.toString();
            }
        }
        return '';
    }
}
